import { Box, Spinner, Text, VStack } from "@chakra-ui/react";

export default function AuthCallback() {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minH="100vh">
      <VStack gap={4}>
        <Spinner size="xl" />
        <Text color="gray.600">Completing sign-in...</Text>
      </VStack>
    </Box>
  );
}